import {
  SAVINGS_CANCEL_CONFIRMATION_START,
  SAVINGS_CANCEL_CONFIRMATION_SUCCESS,
  SAVINGS_CANCEL_CONFIRMATION_ERROR,
  CLEAR_SAVINGS_CANCEL_CONFIRMATION,
} from 'constants/action-types/savings';
import apiAction from 'helpers/apiAction';

export default data => dispatch =>
  dispatch(
    apiAction({
      method: 'post',
      url: '/SavingsCancelConfirmation',
      data,
      onStart: () => dispatch =>
        dispatch({
          type: SAVINGS_CANCEL_CONFIRMATION_START,
        }),
      onSuccess: res => dispatch => {
        const payload = Array.isArray(res) ? res[0] : res || {};
        return dispatch({
          type: SAVINGS_CANCEL_CONFIRMATION_SUCCESS,
          payload,
        });
      },
      onFailure: error => dispatch => {
        const err = Array.isArray(error) ? error[0] : error || {};
        return dispatch({
          type: SAVINGS_CANCEL_CONFIRMATION_ERROR,
          payload: {
            ...err,
          },
        });
      },
    }),
  );

export const clearSavingsCancelConfirmation = () => dispatch => {
  return dispatch({
    type: CLEAR_SAVINGS_CANCEL_CONFIRMATION,
  });
};
